<template>
  <div class="container-fluid abacus-oo-giftcards p-0 mobile-wrapper">
    <!-- <div class="row no-gutters">
            <div class="col">
                <nav class="navbar fixed-top navbar-light bg-light" style="height:56px;">
                    <router-link class="d-flex gift-card-header-button shadow ml-auto" :to="{ name: 'giftcardCheckBalance'}">
                        <img src="../../../assets/images/button-icons/gift-card-icon.svg" style="padding-right:5px;" alt="gift card balance icon"/>
                        Check Gift Card Balance
                    </router-link>
                </nav>
            </div>
        </div> -->
    <div v-if="isMobile()">
      <ShopHeaderMobile :storeid="storeid" :isGiftCard="true" />
    </div>
    <div v-else class="row no-gutters">
      <div class="col">
        <ShopHeader :storeid="storeid" />
      </div>
    </div>

    <div
      :class="[
        'row',
        'no-gutters',
        'justify-content-md-center',
        isMobile() ? 'margin-top-nav' : 'pt-4',
      ]"
    >
      <div class="col-xs-12 col-md-8">
        <div class="container abacus-oo-giftcards-main p-0">
          <router-view :menuLoaded="menuLoaded" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShopHeader from "../../../components/shop/partials/shopheader.vue";
import ShopHeaderMobile from "../../../components/shop/partials/shopheaderMobile";
import shared from "../../../sharedscripts/shop/Checkout/giftCheckout.js";

export default {
  components: {
    ShopHeader,
    ShopHeaderMobile,
  },
  computed: {
    ...shared.computed,
    menuLoaded: {
      get() {
        return this.$store.getters["getloadedMenu"];
      },
    },
  },
  props: {
    showHeader: {
      type: Boolean,
      default: true,
    },
    storeid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      storeLoaded: false,
      showDrawer: false,
    };
  },
  created() {
    //init store and load menus
    // const self = this;
    // this.$store.dispatch("initStore", {
    //   storeId: self.storeid,
    //   callback: async () => {
    //     debugger;
    //     await self.$store.dispatch("getStoreMenu", self.storeid);
    //   },
    // });
  },
};
</script>

<style>
/*@media only screen and (hover: none) and (pointer: coarse){*/
/*    .abacus-oo-giftcards-confirmpayment .right-bottom-section .cart-coupon.cart-totals .row {*/
/*        margin-right: 0px !important;*/
/*        margin-left: 0px !important;*/
/*    }*/

/*    .abacus-oo-giftcards-confirmpayment .right-bottom-section .cart-coupon.cart-totals .row button {*/
/*        width: 100% !important;*/
/*    }*/

/*    .abacus-oo-giftcards-confirmpayment .right-bottom-section .cart-coupon.cart-totals .row img {*/
/*        float: right;*/
/*        margin-left: 0px !important;*/
/*        margin-right: -16px;*/
/*    }*/

/*    .abacus-oo-giftcards-confirmpayment .right-bottom-section .cart-coupon.cart-totals .row .col-sm-8, .abacus-oo-giftcards-confirmpayment .right-bottom-section .cart-coupon.cart-totals .row .col-sm-4{*/
/*        padding-left: 0px !important;*/
/*        padding-right: 0px !important;*/
/*    }*/

/*}*/
.abacus-oo-giftcards
  .abacus-oo-giftcards-confirmpayment
  .gpay-button-fill
  button {
  background-color: rgb(245, 245, 245);
}

.abacus-oo-giftcards .abacus-oo-giftcards-confirmpayment .text-divider {
  margin: 2em 0;
  line-height: 0;
  text-align: center;
}

.abacus-oo-giftcards .abacus-oo-giftcards-confirmpayment .text-divider:before {
  content: " ";
  display: block;
  border-top: 1px solid #e3e3e3;
  border-bottom: 1px solid #f7f7f7;
}

.abacus-oo-giftcards .abacus-oo-giftcards-confirmpayment .text-divider span {
  background-color: white;
  padding: 1em;
  color: #767171;
}

.abacus-oo-giftcards .margin-top-nav {
  margin-top: 4rem;
}

.abacus-oo-giftcards .abacus-oo-giftcards-main {
  border-radius: 2%;
  margin: 0 auto;
}

.abacus-oo-giftcards .gift-card-header-button {
  border-radius: 2%;
  padding: 8px;
  background: white;
  color: rgb(85, 167, 255);
}

.abacus-oo-giftcards .abacus-oo-giftcards-landing-mainpanel .btn.radio-active {
}

.abacus-oo-giftcards .abacus-oo-giftcards-landing-mainpanel button {
  border-radius: 5px;
}

.abacus-oo-giftcards
  .abacus-oo-giftcards-confirmpayment
  .btn.continue-ordering {
  width: 100%;
  border-radius: 2%;
  padding: 8px;
}
</style>
